module.exports = __webpack_public_path__ + "img/MRT.bc61ee08.svg";